import "./Level15.scss";

export default function Level15() {
  return (
    <div className="level15__container">
      <div className="level15__puzzle">
        <div className="level15__grid level15__grid-1">
          <span className="level15__grid-item level15__grid-item--1">A</span>
          <span className="level15__grid-item level15__grid-item--2">B</span>
          <span className="level15__grid-item level15__grid-item--3">C</span>
          <span className="level15__grid-item level15__grid-item--4">D</span>
          <span className="level15__grid-item level15__grid-item--5">E</span>
          <span className="level15__grid-item level15__grid-item--6">F</span>
          <span className="level15__grid-item level15__grid-item--7">G</span>
          <span className="level15__grid-item level15__grid-item--8">H</span>
          <span className="level15__grid-item level15__grid-item--9">I</span>
        </div>

        <div className="level15__grid level15__grid-2">
          <span className="level15__grid-item level15__grid-item--10">
            J <div className="level15__grid-dot level15__grid-dot--1"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--11">
            K <div className="level15__grid-dot level15__grid-dot--2"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--12">
            L <div className="level15__grid-dot level15__grid-dot--3"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--13">
            M <div className="level15__grid-dot level15__grid-dot--4"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--14">
            N <div className="level15__grid-dot level15__grid-dot--5"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--15">
            O <div className="level15__grid-dot level15__grid-dot--6"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--16">
            P <div className="level15__grid-dot level15__grid-dot--7"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--17">
            Q <div className="level15__grid-dot level15__grid-dot--8"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--18">
            R <div className="level15__grid-dot level15__grid-dot--9"></div>
          </span>
        </div>

        <div className="level15__grid level15__grid-3">
          <span className="level15__grid-item level15__grid-item--19">S</span>
          <span className="level15__grid-item level15__grid-item--20">T</span>
          <span className="level15__grid-item level15__grid-item--21">U</span>
          <span className="level15__grid-item level15__grid-item--22">V</span>

          <div className="level15__grid-line level15__grid-line--1"></div>
          <div className="level15__grid-line level15__grid-line--2"></div>
        </div>

        <div className="level15__grid level15__grid-4">
          <span className="level15__grid-item level15__grid-item--23">
            W <div className="level15__grid-dot level15__grid-dot--10"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--24">
            X <div className="level15__grid-dot level15__grid-dot--11"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--25">
            Y <div className="level15__grid-dot level15__grid-dot--12"></div>
          </span>

          <span className="level15__grid-item level15__grid-item--26">
            Z <div className="level15__grid-dot level15__grid-dot--13"></div>
          </span>

          <div className="level15__grid-line level15__grid-line--1"></div>
          <div className="level15__grid-line level15__grid-line--2"></div>
        </div>
      </div>

      <div className="level15__guess-container">
        <div className="level15__guess-item level15__guess-item--1"></div>

        <div className="level15__guess-item level15__guess-item--2">
          <div className="level15__guess-dot level15__guess-dot--1"></div>
        </div>

        <div className="level15__guess-item level15__guess-item--3"></div>

        <div className="level15__guess-item level15__guess-item--4">
          <div className="level15__guess-dot level15__guess-dot--2"></div>
        </div>

        <div className="level15__guess-item level15__guess-item--5"></div>

        <div className="level15__guess-item level15__guess-item--6">
          <div className="level15__guess-dot level15__guess-dot--3"></div>
        </div>

        <div className="level15__guess-item level15__guess-item--7"></div>

        <div className="level15__guess-item level15__guess-item--8"></div>

        <div className="level15__guess-item level15__guess-item--9">
          <div className="level15__guess-dot level15__guess-dot--4"></div>
        </div>

        <div className="level15__guess-item level15__guess-item--10">
          <div className="level15__guess-dot level15__guess-dot--5"></div>
        </div>
      </div>
    </div>
  );
}
